import LocalStorageService from "@application/features/Common/local-storage-service";
import { jwtDecode } from "jwt-decode";
export const getCurrentUserFromJwt = (token) => {
    const authToken = token || LocalStorageService.getAccessToken();
    if (authToken != null) {
        const decodedJWT = jwtDecode(authToken);
        const currentUser = {
            accessToken: authToken,
            id: decodedJWT.UserId,
            name: decodedJWT.Name,
            role: decodedJWT.RoleCategory,
            email: decodedJWT.Email,
        };
        return currentUser;
    }
};
